module.exports = __webpack_public_path__ + "static/media/fleetvehiclesIcon.a1c68950.svg";